var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
export class BlockchainOperationManager {
    constructor(blockSyncService) {
        this.blockSyncService = blockSyncService;
        this.submittingTransactions = new Set();
        this.verifyingTransactions = new Set();
    }
    get state() {
        if (this.submittingTransactions.size > 0) {
            return "SUBMITTING";
        }
        else if (this.verifyingTransactions.size > 0) {
            return "VERIFYING";
        }
        else {
            return "IDLE";
        }
    }
}
__decorate([
    observable
], BlockchainOperationManager.prototype, "submittingTransactions", void 0);
__decorate([
    observable
], BlockchainOperationManager.prototype, "verifyingTransactions", void 0);
__decorate([
    computed
], BlockchainOperationManager.prototype, "state", null);
